module.exports = {
  API_LOCATION: 'https://jvum7co2ul.execute-api.us-east-1.amazonaws.com/v1/',
}
